import { render, staticRenderFns } from "./StandardsDialog.vue?vue&type=template&id=f5d37b5c"
import script from "./StandardsDialog.vue?vue&type=script&lang=js"
export * from "./StandardsDialog.vue?vue&type=script&lang=js"
import style0 from "./StandardsDialog.vue?vue&type=style&index=0&id=f5d37b5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports